/* global G */
import { get, resolve } from 'lib/manager/acl/helper'
import { _defaultAclProps } from 'lib/manager/acl/api/component'
import { getFirstItem } from 'lib/util'

/**
 * hide by role
 * @example see
 * - lib/manager/acl/api/component.js
 * - lib/manager/acl/api/link.js
 *
 * @param {Gaia.Web.Application} obj - native application
 * @returns {function(*=): (*)}
 */
const fn = obj => (item) => {
  if (!item.aclUserRole) return {}

  const aclUserRole = resolve({
    [G.ACL]: { role: item.aclUserRole },
    [G.CONFIGURATION]: item.aclProps ? { aclProps: item.aclProps } : _defaultAclProps,
  })

  try {
    const user = getFirstItem(obj[G.SESSION]?.[G.STATE]?.[G.META]?.refs?.user) || null
    const userRoles = user
      ? user?.value?.roles
        ?.filter(role => role.includes('@'))
        ?.map(role => role.substring(0, role.indexOf('@')))
      : []

    get(obj)[G.API].check(
      userRoles || [],
      aclUserRole[G.ACL],
    )
  } catch (e) {
    return aclUserRole[G.PROPS]
  }
  return {}
}

export default fn
